<template>
  <div class="upload-demo">
    <el-upload
      action
      class="upload-demo"
      :show-file-list="false"
      :http-request="uploadFile"
      :before-upload="beforeVideoUpload"
    >
      <!-- <el-button ref="uploadbtn"> xxx </el-button> -->
      <el-button type="primary" icon="el-icon-upload">上传视频</el-button>
    </el-upload>

    <!-- 上传进度提示 -->
    <div
      v-if="uploadProgress > 0 && uploadProgress < 100"
      class="progress-wrapper"
    >
      <el-progress :percentage="uploadProgress"></el-progress>
    </div>
  </div>
</template>

<script>
import { getDictItem } from "@/api/enrollStudent";
import global from "@/config/global";

export default {
  name: "BasicUploadVideo",
  data() {
    return {
      fileList: [], // 已上传的文件列表
      uploadData: {
        // 额外的上传参数
        type: "avatar",
        userId: 123,
      },
      headers: {
        // 设置请求头，如 token
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      uploadProgress: 0, // 上传进度
    };
  },
  methods: {
    open() {
      console.log("xxxxxxx");
      // this.$refs.uploadbtn.$el.click();
    },
    beforeVideoUpload(file) {
      // 支持常见视频格式
      const validVideoTypes = [
        "video/mp4",
        "video/avi",
        "video/mov",
        "video/wmv",
        "video/flv",
        "video/mkv",
        "video/webm",
        "video/MP4",
        "video/AVI",
        "video/MOV",
      ];

      const isVideo = validVideoTypes.includes(file.type);
      const isLt100M = file.size / 1024 / 1024 < 500; // 限制100MB

      if (!isVideo) {
        this.$message.error(
          "上传视频只能是 MP4、AVI、MOV、WMV、FLV、MKV、WebM 格式!",
        );
        return false;
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过 100MB!");
        return false;
      }

      return isVideo && isLt100M;
    },
    uploadFile(item) {
      let file = item.file;
      getDictItem("cdnAndHttp").then((res) => {
        const value = res.data[0].value;
        Vue.prototype.$POST
          .upload(
            global.baseApi + "admin/sys-file/upload",
            {
              file,
              dir: "person",
              type: 20,
            },
            {
              baseURL: "",
              timeout: 100000,
            },
          )
          .then((res) => {
            console.log("视频", res.data);
            if (res.code == 0) {
              //   this.imageUrl = res.data.cdnUrl;
              this.$message.success("视频上传成功");
              //   this.uploadCancle();
              //   this.form.groupId = "";
              //   this.$emit("uploadRefresh");
            } else {
              this.$message.error("视频上传失败");
            }
          });
      });
    },
    // 上传前校验
    beforeUpload(file) {
      const isJPGorPNG =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt500K = file.size / 1024 / 1024 < 5;

      if (!isJPGorPNG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt500K) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }

      // 重置进度
      this.uploadProgress = 0;
      return true;
    },

    // 上传进度回调
    handleProgress(event, file, fileList) {
      // event.percent 是上传进度百分比
      this.uploadProgress = event.percent;
      console.log("上传进度:", event.percent);
    },

    // 上传成功回调
    handleSuccess(response, file, fileList) {
      this.uploadProgress = 0;
      this.$message.success(`${file.name} 上传成功`);
      console.log("服务器返回:", response);

      // 可以在这里处理服务器返回的文件信息
      if (response && response.data) {
        file.url = response.data.url; // 设置文件访问地址
      }
    },

    // 上传失败回调
    handleError(err, file, fileList) {
      this.uploadProgress = 0;
      this.$message.error(`${file.name} 上传失败`);
      console.error("上传错误:", err);
    },

    // 删除文件回调
    handleRemove(file, fileList) {
      this.$message.info(`${file.name} 已删除`);
      // 可以在这里调用删除接口，删除服务器上的文件
      // this.deleteFile(file.response.id);
    },
  },
};
</script>

<style scoped>
.upload-demo {
}

.progress-wrapper {
  margin-top: 20px;
  width: 300px;
}
</style>
